<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(municipio, index) in listadoMunicipios">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ municipio.nombre }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :municipio="municipio">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ municipio.nombreCorto }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoMunicipios: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },

};
</script>

<style lang="scss">

</style>
